import { motion } from 'motion/react';
import { useGetParams } from '../../hooks/useGetParams';
import { QrCodes } from '../QrCodes/QrCodes';

import styles from './Advt.module.css';

export const Advt = () => {
  const { title } = useGetParams();
  return (
    <div className={styles.advtWrapper}>
      <QrCodes />
      {title && (
        <motion.div
          initial={{ maskPosition: '-100% center' }}
          animate={{
            maskPosition: '0% center',
            transition: { duration: 0.56, delay: 0 },
          }}
          exit={{
            maskPosition: '-100% center',
            transition: { duration: 0.56, delay: 1 },
          }}
          className={styles.title}
        >
          {title}
        </motion.div>
      )}
    </div>
  );
};
